module.exports = __webpack_public_path__ + "02_face.69633b72.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer1/02_face.png
// module id = Yq3q
// module chunks = 0